// extracted by mini-css-extract-plugin
export default {"breadcrumb":"lj-z","breadcrumbItem":"mj-z","hideOnMobile":"nj-z"};